import React from "react";
import { useNavigate } from "react-router-dom";

const BottomNav = ({ active, setActive }) => {
	const items = [
		{ id: "home", label: "Home", icon: "fa-home", path: "/" },
		// { id: "offers", label: "Offers", icon: "fa-tag", path: "/offer-list" },
		// { id: "notifications", label: "Notifications", icon: "fa-bell" },
	];
	const navigate = useNavigate();

	return (
		<div className="bottom-nav">
			{items.map((item) => (
				<div
					key={item.id}
					className={`nav-item ${active === item.id ? "active" : ""}`}
					onClick={() => {
						setActive(item.id);
						navigate(item.path);
					}}
				>
					<i className={`fas ${item.icon} pr-1`}></i>
					<span>{item.label}</span>
				</div>
			))}
		</div>
	);
};

export default BottomNav;
